<template>
    <div>
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          pageTitle: this.pageTitle,
          errMsg: this.errMsg,
          isEdit: this.editMode,
          isWizard: this.wizardMode,
        }"
        v-on:input="formData = $event"
        v-on:next="nextHandler"
        v-on:save="saveHandler"
        v-on:error="errorHandler"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
    </div>
  </template>
  
  <script>
  
  import ReviewExerciseForm from "../../../components/performance/reviewexercise/Form";
  import ErrorDialog from "../../../components/common/ErrorDialog";
  
  export default {
    components: {
      "app-form": ReviewExerciseForm,
      "app-error": ErrorDialog,
    },
  
    data() {
      return {
         pageTitle: this.$t('pmreviewexercise.createnewappraisalexercise'),

        formData: {
          reviewcode: null,
          description: null,
          assessmentid: null,
          assessmentcode: null,
          startdate: null,
          enddate: null,
          formtype: null,
          pmrankmapsetid: null,
          pmrankmapsetcode: null,
          remarks: null,
          pmkpiexerciseid: null,
          pmkpiexercisecode: null,
          statusid: null,
          staffFirst: false,
          initiated: null,
          ongoing: null,
          completed: null,
          stamp: 0,
          userid: this.$store.getters.userId,
        },

        errMsg: "",
        isErr: false,
        editMode: false,
        wizardMode: true,
      };
    },
  
    methods: {
  
      errorHandler($event) {
        this.isErr = $event.isErr;
        this.errMsg = $event.errMsg;
      },
  
      saveHandler() {
        
        const vm = this;

        if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
          return false;
        }

        this.$store.dispatch('post', {url: "/reviewexercise/create", payload: this.formData})
        .then((res) => {
            if (res.data.error) {
              //DEV
              vm.isErr = true; // Set error state to true
              // Format the error messages
              if (Array.isArray(res.data.error)) {
                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
              } else {
                vm.errMsg = res.data.error;
              }
            } else {
                this.$router.push({ name: "reviewexerciselist" });
            }
        })
        .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
        });

      },
    },

    created() {
    }
  };
  </script>